// extracted by mini-css-extract-plugin
export default {"wrapper":"TT-z","availablePromoMessagesLabel":"UT-z","promoMessageList":"VT-z","promoMessage":"WT-z","appliedPromoMessage":"XT-z","promoMessageAmount":"YT-z"};